import { Container, Header } from "components/Page"
import {
  columns as commonColumns,
  getActivateDeactivateActionsColumn,
} from "../common/Vendors/columns"

import Breadcrumbs from "components/Breadcrumbs"
import Surface from "components/Surface"
import VendorsList from "../common/Vendors/List"
import { css } from "@emotion/css"
import { useAuthenticated } from "providers/A12n"
import { useI18n } from "providers/I18n"
import { SelectAgency } from "../components/SelectAgency"

const queryKey = "agency-vendors"

export default function MarketVendors() {
  const { t } = useI18n()
  const { hasAuthority } = useAuthenticated()
  const actionAllowed = hasAuthority(["AUTH_ACCESS_AGENCY_FINANCE"])

  const _columns = actionAllowed
    ? commonColumns.concat([getActivateDeactivateActionsColumn({ queryKey })])
    : commonColumns

  return (
    <Container>
      <Breadcrumbs section={t("nav.admin")} current={t("nav.agency.vendors")} />
      <Header label={t("nav.agency.vendors")}>
        <SelectAgency />
      </Header>
      <Surface className={styles.surface}>
        <VendorsList queryKey={queryKey} columns={_columns} />
      </Surface>
    </Container>
  )
}

const styles = {
  surface: css`
    padding: var(--spacing-xxl-2) var(--spacing-m) var(--spacing-m);
  `,
}
